export default __webpack_public_path__ + "static/d8f39457-732a-49f3-8a19-b484a9d46ffa-691c7d84e1a2be42823d3b0fe96d7baf.woff";